var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiTestingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9458_59505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 46.5,
    height: 46.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9458_59505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 26.5404L20.4596 23L24 19.4596L27.5404 23L24 26.5404ZM20.2383 16.7534L17.2427 13.7573L24 7L30.7573 13.7573L27.7617 16.7534L24 12.9917L20.2383 16.7534ZM14.7573 29.7573L8 23L14.7573 16.2427L17.7534 19.2383L13.9917 23L17.7534 26.7617L14.7573 29.7573ZM33.2427 29.7573L30.2466 26.7617L34.0083 23L30.2466 19.2383L33.2427 16.2427L40 23L33.2427 29.7573ZM24 39L17.2427 32.2427L20.2383 29.2466L24 33.0083L27.7617 29.2466L30.7573 32.2427L24 39Z",
    fill: "#F5B40B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiTestingIcon);
export default __webpack_public_path__ + "static/media/APITestingIcon.b2857fd8bce6e1869d6a5b1407b9598a.svg";
export { ForwardRef as ReactComponent };